export const glacierDoughnutChartColors = ['#4f6d9f', '#213455', '#d7dce5ff', '#2e8ed3'];
export const alexForbesDoughnutChartColors = ['#15808D', '#124E57', '#E7F2F3', '#163338ff'];
export const glacierBarChartColors = {
  primary: '#4f6d9f',
  secondary: '#cfd8e6ff',
  error: '#c91400'
};

export const alexForbesBarChartColors = {
  primary: '#15808D',
  secondary: '#E7F2F3',
  error: '#A5242F'
};
